import React from 'react';

export default function IcArrowUp(props) {
  return (
    <svg width='1em' height='1em' viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path 
        fillRule="evenodd"
        clipRule="evenodd" 
        d="M7.29289 9.70711C6.90237 9.31658 6.90237 8.68342 7.29289 8.29289L11.2929 4.29289C11.6834 3.90237 12.3166 3.90237 12.7071 4.29289L16.7071 8.29289C17.0976 8.68342 17.0976 9.31658 16.7071 9.70711C16.3166 10.0976 15.6834 10.0976 15.2929 9.70711L13 7.41421L13 19C13 19.5523 12.5523 20 12 20C11.4477 20 11 19.5523 11 19L11 7.41421L8.70711 9.70711C8.31658 10.0976 7.68342 10.0976 7.29289 9.70711Z" 
        fill="currentColor" />
    </svg>
  );
}
